import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

interface CraftingTimerProps {
  finishesAt: string;
  duration: number;
}

export function CraftingTimer({ finishesAt, duration }: CraftingTimerProps) {
  const [_update, setUpdate] = useState(0);

  const { t } = useTranslation(undefined, { keyPrefix: 'Arsenal.Forge' });

  useEffect(() => {
    const interval = setInterval(() => setUpdate(u => u + 1), 1000);
    return () => clearInterval(interval);
  }, []);

  const finishDate = new Date(finishesAt);
  const durationText = new Date(finishDate.getTime() - Date.now()).toISOString().slice(11, 19);
  const progress = Math.min(100, Math.floor((duration - (finishDate.getTime() - Date.now())) / duration * 100));

  return (
    <div className="flex flex-col w-full">
      <p className="text-mono text-sm">{progress >= 100 ? t('readyToClaim') : durationText}</p>
      <div className="w-full h-2 bg-tertiary my-1 relative">
        <div
          style={{ width: `${progress}%` }}
          className="h-full bg-primary"
        />
      </div>
      <p className="text-mono text-sm">{progress}%</p>
    </div>
  );
}